import { ActionsUnion, createAction } from '@martin_hotell/rex-tils'
import { SplashScreenActionTypes } from './types'

export const SplashScreenActions = {
  loadSplashScreen: () => createAction(SplashScreenActionTypes.LOAD_SPLASH_SCREEN),
  storePendingSplashScreen: (url: string) => createAction(SplashScreenActionTypes.STORE_PENDING_SPLASH_SCREEN, { url }),
  confirmSplashScreen: () => createAction(SplashScreenActionTypes.CONFIRM_SPLASH_SCREEN),
  clearSplashScreen: () => createAction(SplashScreenActionTypes.CLEAR_SPLASH_SCREEN),
}

export type SplashScreenActionObjectTypes = ActionsUnion<typeof SplashScreenActions>
